import React from "react";
import { useHistory } from "react-router-dom";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import { localStore } from "stores/localStorage";
import { config } from "config/index";
import JarvisCard from "components/JarvisCard";
import JarvisButton from "components/JarvisButton";
import { makeStyles } from "@mui/styles";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const PHCProduct = {
  id: "phc",
  name: "Portfolio Health Check",
  description:
    "Get a FREE AI portfolio check to spot risks & missed returns instantly",
  icon: "/images/product-info/Stethoscope.svg",
  banner: "/images/product-info/PHC-frameBg.svg",
};

const useStyles = makeStyles(() => ({
  featureBox: {
    color: "#2B70C5",
    fontWeight: 500,
  },
}));

const PHCOnboardingNotCompletedContainer = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleInvestNow = () => {
    console.log("check is broker....");
    localStore.setActiveProduct(config.productCodes.PHC);
    history.push("/phc/onboarding/overview");
  };

  return (
    <Stack mt={3}>
      <JarvisCard
        sx={{
          border: "1px solid #d3d3d3",
          position: "relative",
          paddingBottom: "40px",
          marginBottom: "20px",
        }}
      >
        <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
          {/* LEFT SECTION */}
          <Stack sx={{ flex: { xs: 1, md: 2 } }}>
            <Stack direction="row">
              <img
                src={PHCProduct.icon}
                alt=""
                style={{ marginRight: 18 }}
                width="36"
              />
              <Stack>
                <Text
                  variant="subtitle1"
                  sx={{ color: "#2B70C5", fontWeight: 600 }}
                >
                  {PHCProduct.name}
                </Text>
                <Text variant="body2" sx={{ color: "#676E76" }}>
                  {PHCProduct.description}
                </Text>
              </Stack>
            </Stack>

            {/* Feature Boxes */}
            <Stack
              mt={4}
              spacing={2}
              sx={{
                width: { xs: "100%", md: "90%", lg: "80%" },
                mx: { xs: "0", md: "auto" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                gap: "5px",
                alignItems: "center",
                // textAlign: "center",
              }}
            >
              {[
                {
                  icon: "/images/product-info/shield.svg",
                  label: "Find hidden portfolio risks",
                },
                {
                  icon: "/images/product-info/growth.svg",
                  label: "Uncover missed returns",
                },
                {
                  icon: "/images/product-info/stick.svg",
                  label: "Free AI-powered check",
                },
              ].map((item, i) => (
                <Stack
                  key={i}
                  direction="row"
                  alignItems="center"
                  sx={{
                    background: "#ECEFFC",
                    padding: "14px 18px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    transition: "0.2s",
                    justifyContent: "center",
                    width: { xs: "100%", md: "80%", lg: "70%" },
                    "&:hover": { background: "#DCEBFF" },
                  }}
                >
                  <img
                    src={item.icon}
                    width="22"
                    alt=""
                    style={{ marginRight: 12 }}
                  />
                  <Text
                    variant="body2"
                    sx={{ fontWeight: 500, fontSize: { xs: "14px" } }}
                  >
                    {item.label}
                  </Text>
                </Stack>
              ))}
            </Stack>
          </Stack>

          {/* RIGHT SECTION */}
          <Stack sx={{ flex: 1 }}>
            <img
              src={PHCProduct.banner}
              alt=""
              width="100%"
              style={{ marginBottom: 20 }}
            />

            <JarvisButton
              disableEndIcon
              onClick={handleInvestNow}
              sx={{
                fontWeight: 600,
                textTransform: "none",
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <img
                  src="/images/product-info/star.svg"
                  alt=""
                  width="20"
                  height="20"
                />
                <Text
                  sx={{
                    fontWeight: 700,
                    fontSize: { xs: "12px" },
                  }}
                >
                  Get FREE Portfolio Health Check
                </Text>
              </Stack>
            </JarvisButton>
          </Stack>
        </Stack>
      </JarvisCard>
    </Stack>
  );
};

export default withRouter(PHCOnboardingNotCompletedContainer);
